module.exports = __webpack_public_path__ + "img/Artboard_2.cc41945e.jpg";